import {SelectionButton} from "./components/SelectionButton/SelectionButton";
import {Box} from "@mui/material";
import React, {useEffect, useState} from "react";
import {ActionButton} from "../../designSystem/components/ActionButton";

export const MultiSelection = ({ isShow, options, defaultSelected, onChangeSelected, onClickCompleted }) => {
  const [selected, setSelected] = useState<string[]>(defaultSelected);

  useEffect(() => {
    onChangeSelected(selected);
  }, [selected]);

  const onClickOption = (event: React.MouseEvent<HTMLButtonElement>) => {
    const value = event.currentTarget.value; // Retrieve the value of the clicked button
    if (value !== '不限') {
      setSelected((prevSelected) => {
        if (prevSelected.includes(value)) {
          // If value is already selected, remove it
          const nextSelected = prevSelected.filter((type) => (type !== value && type !== '不限'));
          return (nextSelected.length > 0) ? nextSelected : defaultSelected;
        } else {
          // Otherwise, add it to the list
          return [...prevSelected.filter(type => type !== '不限'), value];
        }
      });
    } else {
      setSelected(defaultSelected);
    }
  };

  const onClickVaccineReset = () => {
    setSelected(defaultSelected)
  }

  return (
    <Box
      className={`absolute pb-3 top-full left-0 w-full bg-white border border-gray-100 rounded-bl-lg rounded-br-lg shadow-lg overflow-y-scroll transition-all duration-300 z-30 ${
        isShow ? 'h-72 opacity-100' : 'h-0 opacity-0'}`}
    >
      <Box className={"flex flex-1 flex-row px-4 gap-4 mt-4 pb-3 border-b"}>
        <ActionButton
          fullWidth
          label="重置"
          iconName="fa-refresh"
          color="secondary"
          onClick={onClickVaccineReset}
        />
        <ActionButton
          fullWidth
          label="確定"
          iconName="fa-check-circle"
          onClick={onClickCompleted}
        />
      </Box>
      <div className="grid grid-cols-2 gap-3 p-3">
        {options.map(option => (
          <SelectionButton
            key={option.label}
            selected={selected.includes(option.value)}
            label={option.label}
            value={option.value}
            onClick={onClickOption}
          />
        ))}
      </div>
    </Box>
  )
}
